/**
 * Client Logger - Dev-only console wrapper
 *
 * Suppresses all output in production builds.
 * Use this instead of console.log in client code.
 */

const isDev = import.meta.env.DEV;

/* eslint-disable no-console */
export const logger = {
  debug: (message: string, ...args: unknown[]): void => {
    if (isDev) console.log(`[DEBUG] ${message}`, ...args);
  },
  info: (message: string, ...args: unknown[]): void => {
    if (isDev) console.log(`[INFO] ${message}`, ...args);
  },
  warn: (message: string, ...args: unknown[]): void => {
    if (isDev) console.warn(`[WARN] ${message}`, ...args);
  },
  error: (message: string, ...args: unknown[]): void => {
    console.error(`[ERROR] ${message}`, ...args);
  },
};
/* eslint-enable no-console */

export default logger;
